import React from "react"

const ConceptMappingItem = ({ id, positive, onRemoveMapping }) => (
    <div className="map-group">
        {positive.map(({ id: conceptId, name }, index) => (
            <div key={conceptId} className="map-item map-pos">
                {name}
                {onRemoveMapping && index === positive.length - 1 && (
                    <span
                        className="map-delete"
                        onClick={onRemoveMapping({
                            id,
                            positive,
                        })}
                    />
                )}
            </div>
        ))}
    </div>
)

export default ConceptMappingItem
